import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLoginMutation } from "../services/auth/authService";
import { CircularProgress, IconButton } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { useState } from "react";

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://transoceanica.com.ec/">
        Grupo Transoceanica
      </Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
};

const LoginScreen = () => {
  const [showPass, setShowPass] = useState(false);
  const [login, { isError, error, isLoading, reset }] = useLoginMutation();

  const loginSchema = yup.object().shape({
    email: yup
      .string()
      .email("Ingrese un correo válido")
      .required("El email es requerido"),
    password: yup.string().required("La contraseña es requerida"),
  });

  const { errors, getFieldProps, touched, handleSubmit } = useFormik({
    initialValues: {
      // email: "edmundo@gmail.com",
      // password: "123456",
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: (values) => {
      login({
        email: values.email,
        contrasenia: values.password,
      });
    },
  });

  const submitForm = () => {
    handleSubmit();
  };

  return (
    <Box
      style={{
        backgroundImage: `url("Emision-de-BL-FONDO.png")`,
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          minHeight: "100vh",
          alignItems: "center",
          justifyItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          style={{
            maxWidth: 900,
            background: "#fff",
          }}
        >
          <Grid xs={false} sm={false} md={6} lg={6}>
            <Box
              className="login-side-image"
              style={{
                height: "100%",
                backgroundImage: `url("Emision-de-BL-FOTO.png")`,
                backgroundPosition: "center center",
                backgroundSize: "cover",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  marginTop: 100,
                }}
              >
                <img
                  src="Emision-de-BL-LOGO-GT.png"
                  alt="logo"
                  style={{
                    mixBlendMode: "normal",
                    width: 200,
                  }}
                />
              </div>
            </Box>
          </Grid>
          <Grid xs={12} sm={12} md={6} lg={6}>
            <div
              className="login-form"
              style={{
                minHeight: 550,
                marginLeft: "40px",
                marginRight: "40px",
                textAlign: "center",
              }}
            >
              <br />
              <img
                className="mobile-logo"
                src="Emision-de-BL-LOGO-GT.png"
                alt="logo"
                style={{
                  mixBlendMode: "normal",
                  width: 180,
                }}
              />
              <br />
              <br />
              <Typography variant="h5" align="center">
                Login
              </Typography>
              <Typography
                align="center"
                variant="body2"
                style={{
                  color: "gray",
                }}
              >
                Ingrese sus credenciales para ingresar
              </Typography>
              <br />
              <br />
              <TextField
                placeholder="Ingrese email"
                variant="outlined"
                margin="normal"
                fullWidth
                {...getFieldProps("email")}
                error={Boolean(errors.email && touched.email)}
                helperText={
                  Boolean(errors.email && touched.email) && errors.email
                }
              />
              <TextField
                placeholder="Ingrese contraseña"
                variant="outlined"
                margin="normal"
                fullWidth
                type={showPass ? "text" : "password"}
                {...getFieldProps("password")}
                error={Boolean(errors.password && touched.password)}
                helperText={
                  Boolean(errors.password && touched.password) &&
                  errors.password
                }
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={() => setShowPass(!showPass)}>
                      {!showPass ? <IconEye /> : <IconEyeOff />}
                    </IconButton>
                  ),
                }}
              />
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ marginBottom: 10, width: "100%" }}
              >
                {isError && error && (
                  <Alert severity="error" onClose={reset}>
                    {"data" in error ? `${error.data}` : undefined}
                  </Alert>
                )}
              </Grid>
              <Button
                size="large"
                fullWidth
                variant="contained"
                color="primary"
                onClick={submitForm}
                disabled={isLoading}
                endIcon={
                  isLoading && <CircularProgress color="inherit" size={20} />
                }
              >
                Ingresar
              </Button>
              <br />
              <br />
              <br />
              <Copyright />
            </div>
          </Grid>
        </Grid>
      </div>
    </Box>
  );

  // );
};

export default LoginScreen;
